import { render, staticRenderFns } from "./PrkTags.vue?vue&type=template&id=a063e700&scoped=true&"
import script from "./PrkTags.vue?vue&type=script&lang=js&"
export * from "./PrkTags.vue?vue&type=script&lang=js&"
import style0 from "./PrkTags.vue?vue&type=style&index=0&id=a063e700&scoped=true&lang=scss&"
import style1 from "./PrkTags.vue?vue&type=style&index=1&id=a063e700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a063e700",
  null
  
)

export default component.exports